// extracted by mini-css-extract-plugin
export default {"contactValueText":"CreatorContactDetails_contactValueText__oENKX","contactTag":"CreatorContactDetails_contactTag__D25Un","pendingText":"CreatorContactDetails_pendingText__xi5In"};